export var PriipsPeriod;
(function (PriipsPeriod) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PriipsPeriod[PriipsPeriod["Monthly"] = 0] = "Monthly";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PriipsPeriod[PriipsPeriod["BiMonthly"] = 1] = "BiMonthly";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PriipsPeriod[PriipsPeriod["Weekly"] = 2] = "Weekly";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PriipsPeriod[PriipsPeriod["Daily"] = 3] = "Daily";
})(PriipsPeriod || (PriipsPeriod = {}));
//# sourceMappingURL=result.js.map